import { faCog, faSignInAlt, faSignOutAlt, faTh, faUser, faLayerGroup, faTractor } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Dropdown, Nav, Navbar, Tooltip, OverlayTrigger } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { ROLE_ADMIN, ROLE_SUPER_ADMIN } from "../auth/Auth";

import { TitleTarget } from './teleporters/Title';
import logoNoText from '../../assets/img/ls_logo_print_square.png';
import datumLogoNoText from '../../assets/img/datum_logo_notext.svg';

export const Navigation = (props:any) => {
    const history = useHistory();
    
    const { currentUser } = props;

    async function handleOrgSwitch(userOrg: any) {
        await props.refreshAllCredentials(userOrg.orgId);
        console.log("history", history) // admin || data
        history.push("/switchOrgsFromAdmin");
    }
    const renderTooltip = (messageTooltip:String) => {
        return <Tooltip id="button-tooltip">
                 {messageTooltip}
                </Tooltip>
    }
    const renderAdminButton = () => {
        if(!currentUser || !(currentUser.roleId === ROLE_ADMIN || currentUser.roleId === ROLE_SUPER_ADMIN)) {
            return null;
        }

        return <span>
                    <OverlayTrigger placement="bottom" delay={{ show: 100, hide: 200 }} overlay={renderTooltip("Dashboard")}>
                        <Button className="dashboard-icon-button" variant="secondary" key="admin" href={`/`}>
                            {/*<FontAwesomeIcon icon={faTh} />*/}
                            <img
                                src={logoNoText}
                                width="18px"
                                style={{paddingBottom: "3px"}}
                                className="d-inline-block align-middle logo-padding"
                                alt={"Datum Geospatial"}
                            /> 
                        </Button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" delay={{ show: 100, hide: 200 }} overlay={renderTooltip("Field Manager")}>
                        <Button className="dashboard-icon-button" variant="secondary" key="admin" href={`${process.env.REACT_APP_FIELD_MGR_ROOT_URL}`}>
                            {/*<FontAwesomeIcon icon={faTractor} />*/} 
                            <div className="d-flex justify-content-around nav navbar-logo-parent" style={{ backgroundColor: "white", padding: "1.5px" }}>                
                                <img
                                    src={datumLogoNoText}
                                    width="18px"
                                    style={{paddingBottom: "3px"}}
                                    className="d-inline-block align-middle logo-padding"
                                    alt={"Datum Geospatial"}
                                />
                            </div>   
                        </Button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" delay={{ show: 100, hide: 200 }} overlay={renderTooltip("Data")}>
                        <Button className="dashboard-icon-button" variant="secondary" key="admin" href={`/data/settings`}>
                            <FontAwesomeIcon icon={faLayerGroup} />
                        </Button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" delay={{ show: 100, hide: 200 }} overlay={renderTooltip("Admin")}>
                        <Button className="dashboard-icon-button" variant="secondary" key="admin" href={`/org/profile`}>
                          <FontAwesomeIcon icon={faCog} />
                        </Button>
                  </OverlayTrigger>
                </span>
    }

    const orgOptionLinks = () => {
        if (!props.userOrgs || props.userOrgs.length === 0) {
            return null;
        }

        return (props.userOrgs.map((userOrg: any, i: number) => {
            return (
              <Dropdown.Item onClick={() => handleOrgSwitch(userOrg)} key={i}>
                {userOrg.orgName}
              </Dropdown.Item>
            );
          })
        );
    }

    const renderProfileButton = () => {
        let loginLogoutElement;

        if (currentUser && currentUser.userId) {
            loginLogoutElement = (
                <span>
                    <Dropdown.Item eventKey="1" href="/logout">
                        <FontAwesomeIcon icon={faSignOutAlt} /> Logout
                    </Dropdown.Item>
                    <Dropdown.Divider/>
                    <Dropdown.Item eventKey="2" href="/profile">
                        <FontAwesomeIcon icon={faUser} /> Profile
                    </Dropdown.Item>
                </span>
            );
        } else {
            loginLogoutElement = (
                <span>
                    <Dropdown.Item eventKey="1" href="/login">
                        <FontAwesomeIcon icon={faSignInAlt} /> Login
                    </Dropdown.Item>       
                </span>
            );
        }

        const orgLinks = orgOptionLinks();
        const adminButton = renderAdminButton();

        return(
            <>
            {adminButton}
            <Dropdown alignRight className="dropdown profile">
                <Dropdown.Toggle variant="secondary	" id="profile-dropdown">
                    <FontAwesomeIcon icon={faUser} />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {loginLogoutElement}
                    {currentUser && currentUser.userId && orgLinks ?
                    <>
                        <Dropdown.Divider/>
                        {orgLinks}
                    </> : null
                    }
                </Dropdown.Menu>          
            </Dropdown>
            </>
        );
    }

    return (
        <Navbar variant="dark" sticky="top" bg="dark" expand="lg" id="header" className="justify-content-between py-4">
          <Navbar.Collapse>
            <Nav className="mr-auto text-center text-nowrap">
                <TitleTarget />
            </Nav>
          </Navbar.Collapse>
          {renderProfileButton()}
        </Navbar>
    );
}